export const environment = {
  production: false,
  apiUrl: "https://rtm-test-api.ithub-webhost.net/api",
  environmentName: "QA"
};

